import './bootstrap';
import '../css/app.css';    // Imported css file [TailwindCSS]
import 'phosphor-icons';


// Imported flowbite
import {
    Accordion,
    Carousel,
    Collapse,
    Dial,
    Dismiss,
    Drawer,
    Dropdown,
    Modal,
    Popover,
    Tabs,
    Tooltip,
    initAccordions,
    initCarousels,
    initCollapses,
    initDials,
    initDismisses,
    initDrawers,
    initDropdowns,
    initModals,
    initPopovers,
    initTabs,
    initTooltips
} from 'flowbite';


const accordionSideBarItems = [
    {
        id: 'accordion-sidebar-heading-1',
        triggerEl: document.querySelector('#accordion-sidebar-heading-1'),
        targetEl: document.querySelector('#accordion-sidebar-body-1'),
        active: false
    }
];

// options with default values
const optionsSideBar = {
    alwaysOpen: false,
    activeClasses: 'bg-transparent dark:bg-sky-350',
    inactiveClasses: 'text-gray-500 dark:text-gray-400',
    onOpen: (item) => {
        const accordionSidebar = document.getElementById('accordion-sidebar');
        accordionSidebar.classList.add('bg-sky-100');
        accordionSidebar.classList.add('p-2');
        accordionSidebar.classList.add('rounded-xl');
        const nameSidebar = document.getElementById('accordion-sidebar-heading-1');
        nameSidebar.classList.add('bg-sky-350');
    },
    onClose: (item) => {
        const accordionSidebar = document.getElementById('accordion-sidebar');
        accordionSidebar.classList.remove('bg-sky-100');
        accordionSidebar.classList.remove('p-2');
        accordionSidebar.classList.remove('rounded-xl');
        const nameSidebar = document.getElementById('accordion-sidebar-heading-1');
        nameSidebar.classList.remove('bg-sky-350');
    },
};

const accordion = new Accordion(accordionSideBarItems, optionsSideBar);
